import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const albo: AnaColumn[] = [
    {
      configuration:
      {
        titleGriglia: 'Iscrizione Albo $  descrizioneSede',
        titleForm: 'Iscrizione Albo $  descrizioneSede',
        breadcrumbCaption: 'Iscrizione Albo',
        //idBreadcrumbGroup:'sede',  
        campoTitle: ['descrizioneSede'],
        masterKey: 'id',
        service: 'albo',
        api: 'albo',
        filterList: '/$idSede',
        filterEditor: '?id=$',
        formType: 'simple',
        helpDoc: 'IscrizioneAlbo.html',
        idTabRif:[
          {
            key: 'idSede',
            value: 'idSede'
          },
          
        ],
        queryFilter: [
          
          {
            key: 'idAlbo',
            value: 'id'
          },
          {
            key: 'numeroAlbo',
            value: 'numero'
          },
          
        ],
        nCol: 1,
        toolbarSettings: {
          service: 'sede',
        }
  
      }
  
    },
    {
      itemType: "buttonMenu", colCount: "1", class: "col-12", caption: "", data: [
        {
          type: 'menuToolbar', orderGriglia: 1, colVisible: true, hideOnEdit: true, disableOnUpdate: true, buttons: [
  
            { name: 'Categoria Albo', icon: 'glyphicon icon-categoria-albo-gestore', displayMode: 'in-line', dataSource: 'AlboCategoria', value: 'selectSedi', hint: 'Categorie ALbo', event: '3', location: 'top', visible: true },
            /* { name: 'Cantieri Esterni', icon: 'icon-magazzino-form', displayMode: 'in-line', value: 'CantieriComponent', costantValue: 'soggetti', hint: 'Cantieri Esterni', event: '1', location: 'top' },*/
            { name: 'Cer Trasportabili', icon: 'glyphicon icon-elenco-cer-trasp', displayMode: 'in-line', value: 'ElencocertrasportabiliComponent', wPopUp: "1000", hPopUp: "527", costantValue: 'soggetti', hint: 'Lista EER Trasportabili', event: '1', location: 'top', visible: true },
            /*{ name: 'Automezzi', icon: 'glyphicon icon-documenti-form', displayMode: 'in-line', value: 'NicaFileManagerComponent', costantValue: 'soggetti', hint: 'Lista allegati', event: '1', location: 'top' },*/
            { name: 'Carr. Mobili', icon: 'glyphicon icon-automezzi-form', displayMode: 'in-line', dataSource: 'AlboCarrozzeriaMobile', value: 'CarrozzeriemobiliComponent', wPopUp: "1000", hPopUp: "527", costantValue: 'soggetti', hint: 'Elenco Carrozzerie Mobili', event: '3', location: 'top', visible: true },
  
          ]
        }
      ]
    },
    {
      itemType: "group", colCount: "1", class: "col-12 custom-width-soggetto-group", caption: "Iscrizione Albo", data: [
        {
          type: 'campo', dataField: "numero", caption: "Numero Iscrizione", dataType: "", maxLength: '16', width: 45 * aspect, maxSize: 16,
         colWidth:'350',   
          class: "required", validation: [
            { type: "stringLength", min: "0", max: "45", message: "Lungezza campo superata" },
            { type: "required", message: "Campo Obbligatorio" }
          ],
  
        },
  
        //{ type: "empty", dataField: "", colVisible: false, caption: "", dataType: "" },
  
        {
  
          type: 'campoData', dataField: "dataRilascio", caption: "Data Inizio ", format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "date",
          maxLength: '15', width: 26 * aspect, maxSize: 15,
          colWidth:'150',
        },
        {
  
          type: 'campoData', dataField: "dataScadenza", caption: "Data Scadenza", format: "dd/MM/yyyy", editorType: "dxDateBox", dataType: "date",
          maxLength: '15', width: 26 * aspect, maxSize: 15,
          colWidth:'150',
        },
        { showInColumnChooser:false, type: 'campo', colVisible: false, hideOnEdit: true, dataField: "id", dataType: "" },
        { showInColumnChooser:false, type: 'campo', colVisible: false, hideOnEdit: true, dataField: "idAlbo", dataType: "" },
  
      ]
    },
  ]